exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/premium-hub.js-WebpackMultiOutput";